export default __webpack_public_path__ + "static/media/BlockedIconWhite.4c45cdd8.svg";